import {toastr} from "react-redux-toastr"

import {
    getUserRole,
    getTranslationsByScope,
    DropitState,
    getUserSelectedSupplier,
} from "../../reducers"
import {startLoading, stopLoading} from "../act_loading"
import {
    $getBrands,
    $getCustoms,
    $getTaxes,
    $getTerritoi,
    $getVat,
    $getWarrantyList,
    $validateSeveralProducts,
    isHttpError,
} from "../../requests"
import {ActionTypes} from "../act_types"
import {fetchProducts} from ".."
import {responseType, transform} from "../../../utils/http-res-handler"
import {
    IStandardFields,
    ITechFields,
} from "../../../ui/product-form/_reducers/form-id-state"
import {ITax, ITechRawData} from "../../../models/bo"
import {
    get_Not_DeclinableFromTechfields,
    get_Only_DeclinableFromTechfields,
    getlangFromCache,
    Roles,
} from "../../../utils"
import {LocalStorageKeys} from "../../../utils/local-storage-keys"
import {IFileDetails, rawCaratechListConstructor} from "../../../models"
import {IDropdownOption} from "../../../ui/product-form/_reducers/_utils/product-form-types"
import {
    getSelectedDroopyIds,
    isThisProductValid,
} from "../../reducers/red_products"
import {Multilang} from "../../../models/product/multilang-string"

/**
 * initialiseProductForm
 */
export const initialiseProductForm =
    () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
        const supplier = getUserSelectedSupplier(getState())
        $getCustoms()
            .then((res) =>
                transform(
                    res,
                    getTranslationsByScope(getState(), "toastrLabels"),
                    responseType.json
                )
            )
            .then((response) => {
                dispatch({
                    type: ActionTypes.UPDATE_CUSTOMS,
                    data: response,
                })
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (isHttpError(err)) return err
                toastr.error(
                    err.message ? err.message : "Impossible de contacter le server.",
                    ""
                )
                return err
            })
        $getVat(supplier.supplierName)
            .then((res) =>
                transform(
                    res,
                    getTranslationsByScope(getState(), "toastrLabels"),
                    responseType.json
                )
            )
            .then((response) => {
                dispatch({
                    type: ActionTypes.UPDATE_VAT,
                    data: response,
                })
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (isHttpError(err)) return err
                toastr.error(
                    err.message ? err.message : "Impossible de contacter le server.",
                    ""
                )
                return err
            })
        $getWarrantyList()
            .then((res) =>
                transform(
                    res,
                    getTranslationsByScope(getState(), "toastrLabels"),
                    responseType.json
                )
            )
            .then((response: ITax[]) => {
                dispatch({
                    type: ActionTypes.UPDATE_WARRANTY_LIST,
                    data: response,
                })
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (isHttpError(err)) return err
                toastr.error(
                    err.message ? err.message : "Impossible de contacter le server.",
                    ""
                )
                return err
            })
        $getTaxes(supplier.supplierName)
            .then((res) =>
                transform(
                    res,
                    getTranslationsByScope(getState(), "toastrLabels"),
                    responseType.json
                )
            )
            .then((response: ITax[]) => {
                dispatch({
                    type: ActionTypes.UPDATE_TAXES,
                    data: response,
                })
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (isHttpError(err)) return err
                toastr.error(
                    err.message ? err.message : "Impossible de contacter le server.",
                    ""
                )
                return err
            })
        $getTerritoi()
            .then((res) =>
                transform(
                    res,
                    getTranslationsByScope(getState(), "toastrLabels"),
                    responseType.json
                )
            )
            .then((response) => {
                dispatch({
                    type: ActionTypes.UPDATE_TERRITOI,
                    data: response,
                })
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (isHttpError(err)) return err
                toastr.error(
                    err.message ? err.message : "Impossible de contacter le server.",
                    ""
                )
                return err
            })
        $getBrands()
            .then((res) =>
                transform(
                    res,
                    getTranslationsByScope(getState(), "toastrLabels"),
                    responseType.json
                )
            )
            .then((response) => {
                const r = response.map((e: any, i: number) => ({...e, key: i + 2}))
                dispatch({
                    type: ActionTypes.UPDATE_BRANDS,
                    data: r,
                })
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (isHttpError(err)) return err
                toastr.error(
                    err.message ? err.message : "Impossible de contacter le server.",
                    ""
                )
                return err
            })
    }

export const validateSeveralProducts =
    () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
        dispatch(startLoading())
        const role = getUserRole(getState())
        const productIds = getSelectedDroopyIds(getState())
        const translations = getTranslationsByScope(getState(), "fieldErrors")
        let stop = false
        productIds.forEach((id: string) => {
            if (!isThisProductValid(getState(), id)) {
                toastr.error(translations.invalidProductValidationAttempt, "")
                stop = true
            }
        })
        if (stop) {
            dispatch(stopLoading())
            return
        }
        $validateSeveralProducts(productIds, role)
            .then((responses) =>
                responses.map((res: any) =>
                    transform(
                        res,
                        getTranslationsByScope(getState(), "toastrLabels"),
                        responseType.text
                    )
                )
            )
            .then((response) => {
                dispatch(fetchProducts())
                response.map((id: any) =>
                    dispatch({
                        type: ActionTypes.VALIDATE_PRODUCT,
                        id,
                    })
                )
                toastr.success(translations.productsValidated, "")
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (!isHttpError(err)) {
                    toastr.error(
                        err?.message ? err.message : translations.cantFetchServer,
                        ""
                    )
                }
                return err
            })
            .finally(() => dispatch(stopLoading()))
    }

// export const addVariants = (
//   supplierCode: string,
//   droopyId: string,
//   declined: string[]
// ) => (dispatch: (callback: object) => void, getState: () => object): void => {
//   const translations = getTranslationsByScopes(getState(), [
//     "fieldErrors",
//     "productForm",
//   ])

//   dispatch(startLoading(translations.loadingSendProductForm))
//   $addVariants({
//     supplierName: supplierCode,
//     declinedString: declined,
//     droopyId,
//   })
//     .then((res: any) => {
//       toastr.success(translations.registerProductSuccess, "")
//       dispatch(closeProductForm(droopyId))
//       dispatch(fetchProducts())
//     })
//     .catch((err) => {
//       toastr.error(err.message ? err.message : translations.cantFetchServer, "")
//       return err
//     })
//     .finally(() => dispatch(stopLoading()))
// }

/**
 * getFormDataFromFields
 * @param standardsFieldsValues
 * @param caraTechs
 * @param caraTechParameters
 * @param role
 * @param deletedFileNames
 */
export const getFormDataFromFields = (
    standardsFields: IStandardFields,
    techFields: ITechFields,
    caraTechParameters: ITechRawData[],
    caraTechOptions: { [fieldName: string]: IDropdownOption[] },
    role: Roles,
    deletedFileNames: string[]
): FormData => {
    const isTopRef = standardsFields?.isTopRef?.value || false
    const form = new FormData()
    const lang = getlangFromCache()
    if (role === Roles.MARKET_LEADER) {
        const stored = localStorage.getItem(LocalStorageKeys.SELECTED_SUPPLIER)
        form.append("supplierName", stored as string)
    }

    Object.keys(standardsFields).forEach((key: string) => {
        switch (key) {
            case "vatRate":
                // @ts-ignore
                form.append(key, standardsFields[key].value.vatRate)
                break

            case "taxValues":
                const taxValues = standardsFields[key].value
                taxValues.forEach((tax: ITax) => {
                    tax.value = parseFloat(tax.value + "")
                    if (isNaN(tax.value)) tax.value = 0
                })
                form.append(key, JSON.stringify(standardsFields[key].value))
                break

            case "originCountry":
                form.append(key, JSON.stringify(standardsFields[key].value))
                break

            case "comNode":
            case "techNode":
                form.append(key, standardsFields[key].value.code)
                break

            case "label":
            case "purchaseLabel":
            case "purchaseIntroduction":
            case "buyingReasons":
                const mvalue = Multilang.String.ToString(standardsFields[key].value)
                form.append(key, mvalue)
                break

            case "comTreeState":
            case "techTreeState":
            case "validated":
            case "declinedColorList":
                break

            case "ean":
            case "manufacturerRef":
                if (
                    key === "manufacturerRef" &&
                    standardsFields.manufacturerRef.value === ""
                ) {
                    standardsFields.manufacturerRef.value =
                        standardsFields.supplierRef.value
                }
                standardsFields[key].value = isTopRef ? "" : standardsFields[key].value
                form.append(key, standardsFields[key].value)
                break

            case "price":
                const rawPrice = standardsFields[key].value
                const numericPrice = Number(rawPrice)
                form.append(
                    key,
                    Number.isFinite(numericPrice)
                        ? numericPrice.toFixed(2)
                        : String(rawPrice)
                )
                break

            case "pictures":
            case "pdf":
                standardsFields[key].value.forEach(
                    (item: IFileDetails, index: number) => {
                        if (item.isNew) {
                            form.append(key, item.file)
                        }
                        if (item.isRestored) {
                            form.append(
                                key + "_restored",
                                JSON.stringify({
                                    name: item.name,
                                    path: item.path,
                                })
                            )
                        }
                        form.append(
                            "filesRankJson",
                            JSON.stringify({type: key, name: item.file.name, rank: index})
                        )
                    }
                )
                break

            case "declined":
                if (isTopRef) {
                    // @ts-ignore
                    form.append("declinedString", standardsFields[key].value)
                }
                break

            case "declination":
                if (isTopRef) {
                    // @ts-ignore
                    form.append("declination", standardsFields[key].value)
                }
                break

            default:
                form.append(key, standardsFields[key].value)
                break
        }
    })

    const standardTechFields = techFields
    const sendableStandardCaraTechs = rawCaratechListConstructor(
        standardTechFields,
        caraTechParameters,
        caraTechOptions,
        lang
    )
    const declinableTechFields = isTopRef
        ? get_Only_DeclinableFromTechfields(techFields, true)
        : {}
    Object.keys(declinableTechFields).forEach((key) => {
        const payload = {
            codeEnum: declinableTechFields[key].code,
            name: declinableTechFields[key].label,
            lang,
            type: declinableTechFields[key].regenerateInfos.fieldType,
            declinableList: declinableTechFields[key].value,
        }
        form.append("rawDeclinableCaratechsJson", JSON.stringify(payload))
    })

    sendableStandardCaraTechs.forEach((caratech) =>
        form.append("rawCaratechsJson", JSON.stringify(caratech))
    )
    deletedFileNames.forEach((fileName) =>
        form.append("deletedFileNames", fileName)
    )

    return form
}

// export const checkFieldValidity = <T>(
//   formId: string,
//   field: IFieldProps<T>
// ) => (dispatch: (callback: object) => void, getState: () => object): void => {
//   const notRequiredList = [""]
//   const translations = getTranslationsByScope(getState(), "fieldErrors")
//   const errorMessages = getProductFieldErrors(
//     { [field.code]: field },
//     notRequiredList,
//     translations
//   )
//   dispatch(
//     setErrorTextFromField({
//       formId,
//       code: field.code,
//       errorText: errorMessages[field.code] || "",
//       fieldType: field.fieldType,
//     })
//   )
// }
